module.exports = __webpack_public_path__ + "static/title-ed98d5c9598c21a908f068bfab8cb121.png";